import { getFormProps, useForm } from '@conform-to/react'
import FACTSPull from '@jpgapps/facts-api-pull'
import { json, type ActionFunctionArgs } from '@remix-run/node'
import { Form } from '@remix-run/react'
import { StatusButton } from '#app/components/ui/status-button.js'
import { useIsPending } from '#app/utils/misc.js'

export async function action({}: ActionFunctionArgs) {
	const result = await FACTSPull()
	return json({ result }, { status: 200 })
}

export default function Install() {
	const isPending = useIsPending()

	const [form] = useForm({
		id: 'install-form',
	})

	return (
		<div className="mt-12">
			<div>
				<div className="container py-24 lg:py-32">
					{/* Announcement Banner */}
					{/* End Announcement Banner */}
					{/* Title */}
					<div className="mx-auto mt-5 max-w-2xl text-center">
						<h1 className="scroll-m-20 text-4xl font-extrabold tracking-tight lg:text-5xl">
							JPG Apps
						</h1>
					</div>
					{/* End Title */}
					<div className="mx-auto mt-5 max-w-3xl text-center">
						<p className="text-xl text-muted-foreground">
							Let's install JPG Apps
						</p>
					</div>
					{/* Buttons */}
					<div className="mt-8 flex justify-center gap-3">
						<Form method="POST" {...getFormProps(form)}>
							<StatusButton
								status={isPending ? 'pending' : form.status ?? 'idle'}
								type="submit"
								disabled={isPending}
								size={'lg'}
								className="w-52"
							>
								{isPending ? 'Installing...' : 'Install'}
							</StatusButton>
						</Form>
					</div>
					{/* End Buttons */}
				</div>
			</div>
		</div>
	)
}
